// Status formatting utilities
export const formatStatus = (status) => {
  const statusMap = {
    'PENDING_APPROVAL': 'Pending Approval',
    'APPROVED_FOR_PO': 'Approved for PO',
    'NOT_APPROVED_FOR_PO': 'Not Approved',
    'PO_GENERATED': 'PO Generated',
    'SUBMISSION_OPEN': 'Submission Open',
    'SUBMISSION_CLOSED': 'Submission Closed',
    'PURCHASE_ORDER_GENERATED': 'PO Generated',
    'APPROVED': 'Approved',
    'REJECTED': 'Rejected',
    'DRAFT': 'Draft',
    'IN_PROGRESS': 'In Progress',
    'COMPLETED': 'Completed'
  };

  return statusMap[status] || status?.split('_').map(word =>
    word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
  ).join(' ') || 'Unknown';
};

export const getStatusColor = (status) => {
  const colorMap = {
    'PENDING_APPROVAL': 'bg-yellow-100 text-yellow-800',
    'APPROVED_FOR_PO': 'bg-green-100 text-green-800',
    'NOT_APPROVED_FOR_PO': 'bg-red-100 text-red-800',
    'PO_GENERATED': 'bg-blue-100 text-blue-800',
    'SUBMISSION_OPEN': 'bg-indigo-100 text-indigo-800',
    'SUBMISSION_CLOSED': 'bg-gray-100 text-gray-800',
    'PURCHASE_ORDER_GENERATED': 'bg-blue-100 text-blue-800',
    'APPROVED': 'bg-green-100 text-green-800',
    'REJECTED': 'bg-red-100 text-red-800',
    'DRAFT': 'bg-gray-100 text-gray-800',
    'IN_PROGRESS': 'bg-yellow-100 text-yellow-800',
    'COMPLETED': 'bg-green-100 text-green-800'
  };

  return colorMap[status] || 'bg-gray-100 text-gray-800';
};

export const getStatusIcon = (status) => {
  const iconMap = {
    'PENDING_APPROVAL': '⏳',
    'APPROVED_FOR_PO': '✅',
    'NOT_APPROVED_FOR_PO': '❌',
    'PO_GENERATED': '📄',
    'SUBMISSION_OPEN': '📝',
    'SUBMISSION_CLOSED': '🔒',
    'PURCHASE_ORDER_GENERATED': '📄',
    'APPROVED': '✅',
    'REJECTED': '❌',
    'DRAFT': '📝',
    'IN_PROGRESS': '🔄',
    'COMPLETED': '✔️'
  };

  return iconMap[status] || '';
};